import React from 'react'

const onTicketsPage = window.location.pathname.includes('tickets')

export function ProductTable({ children }) {
  return (
    <div>
      <table
        className="product-table"
        data-testid={onTicketsPage ? 'tickets-product-table' : 'cart-product-table'}
        id={onTicketsPage ? 'tickets-product-table' : 'cart-product-table'}
      >
        <thead className="sr-only">
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Quantity</th>
            <th scope="col">Unit Price</th>
            <th scope="col">Total Price</th>
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  )
}
